import { BOX_STATUS, type StatusLabel } from "./labels";

/** How many boxes Home lists, newest first, before "View all boxes". */
export const HOME_BOX_LIMIT = 5;

/** The fields of a `boxes.list` row that decide where it stands. */
export interface BoxStandingInput {
  status: "draft" | "active" | "archived";
  rule: { refreshStatus: "ok" | "unavailable" };
}

/**
 * The one badge Home shows for a box beside its "Sell in store" switch: rules that no longer
 * build it (a listed product shows sold out) ahead of its lifecycle ("Ready", "Not ready yet").
 */
export function boxStanding(box: BoxStandingInput): StatusLabel {
  if (box.rule.refreshStatus === "unavailable") return { label: "Can't rebuild", tone: "critical" };
  return BOX_STATUS[box.status];
}

/** Every row of a status tally, added up. */
export function tallyTotal(tally: Record<string, number> | undefined): number {
  return Object.values(tally ?? {}).reduce((a, b) => a + b, 0);
}
